module.exports = __webpack_public_path__ + "static/media/SR100 Copy.ff2ea42d.png";